export default __webpack_public_path__ + "static/media/info.ea542180.svg";